import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  QUERIES,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { useQueryRequest } from './QueryRequestProvider'
import { useModal } from '../../../../../components'
import { getAtendimentosByFatura, getAtendimentosByFaturaByEmpresa } from './_requests'
import { useParams } from 'react-router-dom'
import { FaturaAtendimentoList } from './_models'

const QueryResponseContext = createResponseContext<FaturaAtendimentoList>(initialQueryResponse)
export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()
  const { idFatura, idEmpresa } = useParams<{ idFatura: string; idEmpresa?: string }>()

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  // A chave inclui a fatura (e a instituição): sem isso, faturas diferentes dividiam o cache.
  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery(
    [QUERIES.FATURAS_ATENDIMENTOS_LIST, idFatura, idEmpresa, query],
    () =>
      idEmpresa
        ? getAtendimentosByFaturaByEmpresa(Number(idFatura), Number(idEmpresa), query)
        : getAtendimentosByFatura(Number(idFatura), query),
    {
      cacheTime: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: !isOpen,
    }
  )

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
